module.exports = __webpack_public_path__ + "img/Fantástico.9aa5dadf.svg";